import { BaseService } from 'hungry-core2'

import actions from '@actions'

export class ThreePlProvidersService extends BaseService {
  setProviders(providers) {
    this.dispatch(actions.setThreePLProviders(providers))
  }
}
